import React, { useEffect, useState } from "react";
import Layout from "../layoutComponent/Layout";
import toast from "react-hot-toast";
import axios from "axios";
import { liveUrl } from "../../utils/Constant";
import Pagination from "../Modals/Pagination";
import DocItem from "../Modals/complimentory-pi";

const PiInsuarance = () => {
    const [formData, setFormData] = useState([]);
    const [viewData, setViewData] = useState(null);
    const [viewOpen, setViewOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 5;

    const fetchPiInsuarance = async () => {
        try {
            const res = await axios.get(`${liveUrl}/pi-application/all?page=${page}&limit=${limit}`, {

            });
            // console.log(res)
            if (Array.isArray(res.data.data)) {
                setFormData(res.data.data);
                setTotalPages(res.data.pagination.totalPages);
            } else {
                setFormData([]);
            }
        } catch (error) {
            toast.error("Failed to load data");
            setFormData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPiInsuarance();
    }, [page]);

    const handleDelete = async (id) => {
        const confirmDelete = await new Promise((resolve) => {
            const toastId = toast(
                (t) => (
                    <div>
                        <p>Are you sure you want to delete this entry?</p>
                        <div style={{ marginTop: "8px", display: "flex", gap: "8px", justifyContent: 'center', alignItems: 'center' }}>
                            <button
                                onClick={() => {
                                    toast.dismiss(t.id);
                                    resolve(true);
                                }}
                                style={{
                                    background: "red",
                                    color: "white",
                                    borderRadius: "4px",
                                    border: 'none',
                                    padding: "4px 8px",
                                    cursor: "pointer",
                                }}
                            >
                                Yes
                            </button>
                            <button
                                onClick={() => {
                                    toast.dismiss(t.id);
                                    resolve(false);
                                }}
                                style={{
                                    background: "gray",
                                    color: "white",
                                    borderRadius: "4px",
                                    border: 'none',
                                    padding: "4px 8px",
                                    cursor: "pointer",
                                }}
                            >
                                No
                            </button>
                        </div>
                    </div>
                ),
                { duration: Infinity }
            );
        });

        if (!confirmDelete) return;

        try {
            await axios.delete(`${liveUrl}/pi-application/${id}`, {

            });

            setFormData((prev) => prev.filter((item) => item._id !== id));
            toast.success("Deleted successfully");
        } catch (error) {
            toast.error("Failed to delete");
        }
    };

    const handleView = (item) => {
        setViewData(item);
        setViewOpen(true);
    };

    return (
        <Layout>
            <div className="banner-container">
                <div className="banner-header">
                    <h2>Complimentory Pi Data</h2>
                </div>

                {loading ? (
                    <p style={{ textAlign: "center" }}>Loading...</p>
                ) : (
                    <div className="table-wrapper">
                        <table className="banner-table">
                            <thead>
                                <tr>
                                    <th>S.NO</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Action</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {formData.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>
                                            No data found
                                        </td>
                                    </tr>
                                ) : (
                                    formData.map((item, index) => (
                                        <tr key={item._id}>
                                            <td>{(page - 1) * limit + index + 1}</td>
                                            <td>{item.name}</td>
                                            <td>{item.emailId}</td>
                                            <td>{item.mobileNo}</td>
                                            <td>
                                                <button
                                                    onClick={() => handleView(item)}
                                                    style={{
                                                        background: "#017AD5",
                                                        color: "#fff",
                                                        padding: "4px 10px",
                                                        borderRadius: "4px",
                                                        border: "none",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    View
                                                </button>
                                            </td>
                                            <td>
                                                <button
                                                    className="delete-btn"
                                                    onClick={() => handleDelete(item._id)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            {viewOpen && viewData && (
                <div className="modal-overlay">
                    <div className="modal-box">

                        {/* Header */}
                        <div className="modal-header">
                            <h3>PI Application Details</h3>
                            <button className="close-icon" onClick={() => setViewOpen(false)}>
                                ✕
                            </button>
                        </div>

                        {/* Basic Info */}
                        <div className="info-grid">
                            {viewData.name && (
                                <div>
                                    <span>Name</span>
                                    <p>{viewData.name}</p>
                                </div>
                            )}

                            {viewData.emailId && (
                                <div>
                                    <span>Email</span>
                                    <p>{viewData.emailId}</p>
                                </div>
                            )}

                            {viewData.mobileNo && (
                                <div>
                                    <span>Mobile</span>
                                    <p>{viewData.mobileNo}</p>
                                </div>
                            )}

                            {viewData.medicalCouncilNo && (
                                <div>
                                    <span>Medical Council No</span>
                                    <p>{viewData.medicalCouncilNo}</p>
                                </div>
                            )}

                            {viewData.qualification && (
                                <div>
                                    <span>Qualification</span>
                                    <p>{viewData.qualification}</p>
                                </div>
                            )}

                            {viewData.yearOfQualification && (
                                <div>
                                    <span>Year of Qualification</span>
                                    <p>{viewData.yearOfQualification}</p>
                                </div>
                            )}

                            {viewData.address && (
                                <div className="full">
                                    <span>Address</span>
                                    <p>{viewData.address}</p>
                                </div>
                            )}
                        </div>

                        {/* Documents */}
                        <h4 className="section-title">Uploaded Documents</h4>

                        <div className="doc-list">
                            <DocItem label="Aadhaar" file={viewData.aadhaarDoc} />
                            <DocItem label="PAN" file={viewData.panDoc} />
                            <DocItem label="Degree Certificate" file={viewData.degreeCertificate} />
                            <DocItem label="Registration Certificate" file={viewData.registrationCertificate} />
                            <DocItem label="Visiting Card" file={viewData.visitingCard} />
                        </div>

                    </div>
                </div>
            )}

            <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={(newPage) => setPage(newPage)}
            />
        </Layout>
    );
};

export default PiInsuarance;
